/**
 * API configuration 
 * 
 * @created: MAZ - 6-Abr-2020
 * @updated: MAZ - 22-Dic-2020
 * 
 */
import { queryStr } from './helpers';

const _REMOTES = [
  { code: 'PROD', label:'Tremé', protocol: 'https', host: 'treme.com.ar', port: '' },
  // { code: 'ALT', protocol: 'https', host: 'api.treme.io', port: '' },
  { code: 'LOCAL', label:'local', protocol: 'http', host: '127.0.0.1', port: '8621' },
]

export var API = {

  VERSION: 'v2', // la version de la API
  ORIGIN: '',    // must be set with API.origin()
  BASE_URL: '/api/v2',
  AUTH_TOKEN: null, // el Token de autorizacion obtenido al login
  DEPRECATED_AUTHORIZED: null, // Old authorized string used by API_v1

  reset () {
    API.AUTH_TOKEN = null // resetamos esto
    API.DEPRECATED_AUTHORIZED = null
    API.saveState()  // y guardamos !
  },

  remotes () {
    // Return all available remote Servers
    return _REMOTES 
  },

  remote (key) {
    // Find and return the given remote
    // if nothing found return NULL
    for (let j = 0; j < _REMOTES.length; j++) {
      if (_REMOTES[j].code === key)
        return _REMOTES[j]
    }
    return null
  },

  token (token) {
    if (token === undefined) return API.AUTH_TOKEN
    API.AUTH_TOKEN = token // guardamos aqui para uso posterior
    API.saveState()
  },

  authorized (str) {
    if (str === undefined) return API.DEPRECATED_AUTHORIZED
    API.DEPRECATED_AUTHORIZED = str // guardamos aqui para uso posterior
    API.saveState()
  },

  url (url, params) {
    return (API.ORIGIN + API.BASE_URL + url +
            (params ? queryStr(params) : ''))
  },

  origin (protocol, host, port, label) {
    /// Setea o devuelve el API.ORIGIN
    // ej: origin('http', 'localhost', 5000)
    // ej: origin('http', 'treme.io')
    // ej: origin() -> 'http://...'
    if (protocol === undefined) { return API.ORIGIN }
    protocol = protocol.replace(':', '') // por si viene http: y no http solo
    API.ORIGIN = (protocol ? protocol + '://' : '') +
                  (host) +
                  (port ? ':' + port : '')
    return API.ORIGIN
  },

  saveState () {
    if (localStorage) {
      localStorage.setItem('api', JSON.stringify({
        origin: API.ORIGIN,
        version: API.VERSION,
        token: API.AUTH_TOKEN,
        deprecated: API.DEPRECATED_AUTHORIZED
      }))
    }
  },

  restoreState () {
    if (localStorage) {
      var str = localStorage.getItem('api');
      var api = str ? JSON.parse(str) : null;
      if (api) {
        API.ORIGIN = api.origin
        API.VERSION = api.version
        API.AUTH_TOKEN = api.token
        API.DEPRECATED_AUTHORIZED = api.deprecated
      }
    }
  },
}

export default API ;
